import React from 'react'
import PropTypes from 'prop-types'
import {Button, Alert} from 'antd'
import {FormattedMessage} from 'react-intl'

function OAuthError ({error, errorDescription, loginRetryUri}) {
  return (
    <div style={styles.container}>
      <Alert
        description={errorDescription}
        message={error}
        style={styles.alert}
        type='warning'
      />
      {loginRetryUri ? (
        <Button
          href={loginRetryUri}
          style={styles.button}
          type='primary'
        >
          <FormattedMessage id='login.retry' />
        </Button>
      ) : null}
    </div>
  )
}

OAuthError.propTypes = {
  error: PropTypes.string.isRequired,
  errorDescription: PropTypes.string.isRequired,
  loginRetryUri: PropTypes.string
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '100%',
    width: '100%'
  },
  alert: {
    minWidth: '40%',
    maxWidth: '80%',
    marginBottom: 30
  },
  button: {
    width: 200
  }
}

export default OAuthError
